import {Injectable} from '@angular/core';
import {CheckInService} from '../api/check-in.service';
import {CheckInFlowData, CheckInFlowSignatureLink} from '../../shared/models/check-in-flow.model';
import {forkJoin, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {requiresCheckIn, Reservation} from '../../shared/models/reservation.model';
import {PaymentsService} from '../api/payments.service';
import {requiresDeposit} from '../../shared/models/payment-status.model';

@Injectable({providedIn: 'root'})
export class CheckInFlowService {
    constructor(
      private checkInService: CheckInService,
      private paymentService: PaymentsService,
      ) {
    }

    get(reservation: Reservation): Observable<CheckInFlowData> {
        return forkJoin({
          checkIns: this.checkInService.getCheckIns(),
          checkInStatus: this.checkInService.getCheckInStatus(),
          paymentStatus: this.paymentService.getPaymentStatus()
        }).pipe(
            map(({checkIns, checkInStatus, paymentStatus}) => {
                const pendingAdultSignatureLinks: CheckInFlowSignatureLink[] = checkInStatus.pendingSignedCheckins
                    .map(pendingCheckIn => {
                        const matchingCheckIn = checkIns.find(
                            checkIn => checkIn.travelRegisterId === pendingCheckIn.travelRegisterId && null == checkIn.signature_image
                        );
                        return matchingCheckIn
                            ? {
                                travelRegisterId: matchingCheckIn.travelRegisterId,
                                name: matchingCheckIn.NAME + ' ' + matchingCheckIn.SURNAME,
                                email: matchingCheckIn.email,
                                contractUrl: matchingCheckIn.contractUrl,
                            }
                            : null;
                    })
                    .filter(item => item !== null) as CheckInFlowSignatureLink[];

                const pendingMinorSignatureLinks: CheckInFlowSignatureLink[] = checkInStatus.pendingSignedCheckinsChildren
                    .map(pendingCheckIn => {
                        const matchingCheckIn = checkIns.find(
                            checkIn => checkIn.travelRegisterId === pendingCheckIn.travelRegisterId && null == checkIn.signature_image
                        );
                        return matchingCheckIn
                            ? {
                                travelRegisterId: matchingCheckIn.travelRegisterId,
                                name: matchingCheckIn.NAME + ' ' + matchingCheckIn.SURNAME,
                                email: matchingCheckIn.email,
                                contractUrl: '',
                            }
                            : null;
                    })
                    .filter(item => item !== null) as CheckInFlowSignatureLink[];

                return {
                    checkinCompleted: checkInStatus.checkin_completed,
                    checkins: checkInStatus.checkins,
                    checkinsMinors: checkInStatus.checkinsChildren,
                    hasPendingAdultCheckIn: checkInStatus.adults > checkInStatus.checkins,
                    hasPendingMinorCheckIn: checkInStatus.children > checkInStatus.checkinsChildren,
                    pendingAdultCheckIn: checkInStatus.adults - checkInStatus.checkins,
                    pendingMinorCheckIn: checkInStatus.children - checkInStatus.checkinsChildren,
                    hasPendingAdultSignature: checkInStatus.pendingSignedCheckins.length > 0,
                    hasPendingMinorSignature: checkInStatus.pendingSignedCheckinsChildren.length > 0,
                    pendingAdultSignatureLinks: pendingAdultSignatureLinks,
                    pendingMinorSignatureLinks: pendingMinorSignatureLinks,
                    hasPendingDeposit: requiresDeposit(paymentStatus),
                    requiresCheckIn: requiresCheckIn(reservation),
                };
            })
        );
    }
}
